import type { IndividualPaymentEditorViewModel } from '@/shared/api/generated';
import { useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor } from '@/shared/api/generated';

/**
 * Carga do formulário de edição de um plano financeiro.
 *
 * A resposta é a **base do corpo do `PUT`**, não só a fonte dos valores do
 * formulário: quatro campos do `IndividualPaymentSaveViewModel` não são exibidos
 * na tela e precisam ser devolvidos como vieram (ver `buildPlanSavePayload`).
 * Por isso o editor cru é exposto, e não apenas os campos mapeados.
 *
 * A query fica desabilitada enquanto o `financialPersonId` não for válido, para
 * não disparar request com `NaN` na URL.
 *
 * @param financialPersonId - ID do contrato financeiro; `null` quando o
 *   parâmetro de rota não é um número válido.
 *
 * @example
 * ```tsx
 * const { editor, isLoading, isError, refetch } = usePlanEditor(101);
 * ```
 */
export function usePlanEditor(financialPersonId: number | null) {
  const { data, isLoading, isError, refetch } =
    useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor(
      financialPersonId ?? 0,
      undefined,
      { query: { enabled: financialPersonId !== null } },
    );

  const editor: IndividualPaymentEditorViewModel | undefined = data ?? undefined;

  return {
    editor,
    isLoading: financialPersonId !== null && isLoading,
    isError,
    refetch,
  } as const;
}
